import { useAnalytics } from "@codat/analytics";
import {
  CircleEmptyQuestionIcon,
  IconButton,
  Tooltip,
  TooltipContent,
  Typography,
} from "@codat/orchard-ui";
import React, { useState } from "react";

import styles from "./HelpTooltip.module.scss";

export const HelpTooltip = () => {
  const { sendEvent } = useAnalytics();
  const [showTooltip, setShowTooltip] = useState(false);

  const handleOpenTooltip = () => {
    sendEvent("API Keys - Authorization header tooltip - Hover");
    setShowTooltip(true);
  };

  const handleCloseTooltip = () => {
    setShowTooltip(false);
  };

  return (
    <Tooltip
      id="authorization-header-tooltip"
      data-testid="authorization-header-tooltip"
      isOpen={showTooltip}
      className={styles.tooltip}
      placement="top"
      content={
        <TooltipContent>
          <div className={styles.tooltipText}>
            <Typography as="p" variant="heading_xs">
              Authorization header
            </Typography>
            <Typography as="p" variant="body_sm">
              This is a base64-encoded version of your API key. Use this in our
              API ref. or Postman to access Codat&apos;s API.
            </Typography>
          </div>
        </TooltipContent>
      }
    >
      <IconButton
        className={styles.button}
        label="Show authorization header information"
        onMouseEnter={handleOpenTooltip}
        onFocus={handleOpenTooltip}
        onBlur={handleCloseTooltip}
        onMouseLeave={handleCloseTooltip}
      >
        <CircleEmptyQuestionIcon />
      </IconButton>
    </Tooltip>
  );
};
